import state from './moduleIdManagementState.js'
import mutations from './moduleIdManagementMutations.js'
import actions from './moduleIdManagementActions.js'
import getters from './moduleIdManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

